import type { ModelId } from "@/hooks/use-model";

type ResolveActiveChatModelInput = {
  sessionOverride?: string | null;
  initialOverride?: string | null;
  persistedModel?: string | null;
  agentModel?: string | null;
  userModel: ModelId;
};

const validModel = (model: string | null | undefined): model is ModelId =>
  typeof model === "string" && model.trim().length > 0;

/** Resolve the model shown in chat and sent to the provider. */
export const resolveActiveChatModel = ({
  sessionOverride,
  initialOverride,
  persistedModel,
  agentModel,
  userModel,
}: ResolveActiveChatModelInput): ModelId => {
  if (validModel(sessionOverride)) return sessionOverride;
  if (validModel(initialOverride)) return initialOverride;
  if (validModel(persistedModel)) return persistedModel;
  if (validModel(agentModel)) return agentModel;
  return userModel;
};
